import { Dimension } from '@/components/utils/ResponsiveImage/ResponsiveImage.models';

export const resizeImageUrl = (url: string, [width, height]: Dimension): string => `${url}?tr=r,${width},${height}`;
